import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import { BuildContext } from "../classes/BuildContext";

export interface InCallTypeCountViewProps extends BaseUIProps {
  key?: string;
  count?: number;
}

class _InCallTypeCountViewState extends ObservableComponent<InCallTypeCountViewProps> {
  static defaultProps = { count: 0 };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: InCallTypeCountViewProps) {
    super(props);

    this.initState();
  }
  public get count(): number {
    return this.props.count;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["count"], this.rebuild);
  }
  public componentDidUpdate(prevProps: InCallTypeCountViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.count !== this.props.count) {
      this.fire("count", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Row({
      mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
      children: [
        ui.Column({
          mainAxisAlignment: ui.MainAxisAlignment.center,
          children: [
            TextView({
              data: this.count.toString(),
              style: new ui.TextStyle({
                color: cStyle.c5,
                fontSize: cStyle.tTextViewDisplayHeadingOneFontSizeOn,
                fontWeight: cStyle.tTextViewDisplayHeadingOneFontWeightOn,
              }),
              className: "xb7f",
              key: "0",
            }),
            TextView({
              data: "In-call",
              style: new ui.TextStyle({
                color: cStyle.c5,
                fontSize: cStyle.tTextViewHeadlineSixFontSizeOn,
                fontWeight: cStyle.tTextViewHeadlineSixFontWeightOn,
              }),
              className: "x0fd3",
              key: "1",
            }),
          ],
          key: "0",
        }),
        ui.AssetImage({
          path: "images/TeamsImg.png",
          width: 119,
          height: 74,
          className: "x241 hc vc",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "InCallTypeCountView xfde hc h"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function InCallTypeCountView(props: InCallTypeCountViewProps) {
  return React.createElement(_InCallTypeCountViewState, {
    ..._InCallTypeCountViewState.defaultProps,
    ...props,
  });
}
